import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SIZE } from '../../../constants/size'
import { FormModalContainer, useCloseConfirm } from '../../Form'
import { MODAL_HEADER_VARIANT } from '../../Modal'
import { UserInvitationForm } from '../UserInvitationForm'

import { QA_NAME_USER_INVITATION_MODAL } from './UserInvitationFormModal.constants'

import * as styles from './UserInvitationFormModal.module.css'

function UserInvitationFormModal({
  qaName = QA_NAME_USER_INVITATION_MODAL,
  title = 'Modal.SendInvitationTitleKey',
  onClose,
  ...restProps
}) {
  const { t } = useTranslation()

  const [modal, setModal] = useState(null)

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  return (
    <UserInvitationForm
      {...restProps}
      FormContainer={FormModalContainer}
      containerProps={{
        boxProps: {
          className: styles.box,
        },
        boxSize: SIZE.LARGE,
        headerVariant: MODAL_HEADER_VARIANT.EDIT,
        isCloseConfirm,
        modal,
        qaName,
        setCloseConfirm,
        title: t(title),
        onClose,
      }}
      setModal={setModal}
      onCancel={handleClose}
      onClose={onClose}
    />
  )
}

export default UserInvitationFormModal
